import validateCaseId from './validateCaseId';

export default validateCaseId;
